export default __webpack_public_path__ + "static/media/arrowRight.6df95240.svg";